import React from 'react'
import { debounce } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import { search, clear } from '../store/reducers/search.js'
import { isResultExists, getResult } from '../selectors/search.js'

import Form from './../components/Form'
import Result from './../components/Search/Result'

const SearchContainer = ({ query, onSubmit, onChange, result, isResultExists, onAfterClick, searched, intl }) => {
  return (
    <div>
      <div className='Search__body'>
        <Form placeholder='Поиск' value={query} onInput={onChange} onSubmit={onSubmit} disableBtn />
      </div>
      { isResultExists && (
        <div className='Search__result'>
          <Result items={result.actions} title="Акции" type='action' onAfterClick={onAfterClick} />
          <Result items={result.externalpartners} title="Партнеры" type='externalpartner' onAfterClick={onAfterClick} />
          <Result items={result.funds} title={intl.formatMessage({id: 'search.foundation'})} type='fund' onAfterClick={onAfterClick} />
        </div>
      )}

      {(!isResultExists && searched) && (
        <div className='Search__result'>
          По вашему запросу ничего не найдено
        </div>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  result: getResult(state),
  storeQuery: state.search.query,
  isResultExists: isResultExists(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ search, clear }, dispatch)

export default injectIntl(compose(
  withState('query', 'setQuery', ''),
  withState('searched', 'setSearched', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSubmit: ({ search, clear, query, setSearched, searched }) => debounce(async () => {
      clear()

      if (!query || query.length < 3) {
        await setSearched(false)
        return false
      }

      await search(query)
      if (!searched) await setSearched(true)
    }, 300)
  }),
  withHandlers({
    onSubmit: ({ onSubmit }) => e => {
      e && e.preventDefault()
      onSubmit()
    },
    onChange: ({ setQuery, onSubmit, setSearched, searched }) => value => {
      if (searched) setSearched(false)
      setQuery(value)
      onSubmit()
    }
  }),
  lifecycle({
    componentWillUnmount () {
      this.props.clear()
      this.props.setQuery('')
    }
  })
)(SearchContainer))



// WEBPACK FOOTER //
// ./src/containers/Search.jsx